import { render, staticRenderFns } from "./AccessDeniedIndex.vue?vue&type=template&id=2c9f113c&scoped=true&"
import script from "./AccessDeniedIndex.vue?vue&type=script&lang=js&"
export * from "./AccessDeniedIndex.vue?vue&type=script&lang=js&"
import style0 from "./AccessDeniedIndex.vue?vue&type=style&index=0&id=2c9f113c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9f113c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VBtn,VContainer,VIcon,VMain})
